var nurseslounge_degrees_home = {
    init:function($params){
        nurseslounge_degrees_home.degrees_home_first_load($params);
        nurseslounge_degrees_home.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
    },
    degrees_home_first_load:function($params){
        var $degreesHomeLeft = $("#nurseslounge-degrees-home .nurseslounge-degrees-home-left");
        var $degreeForm = $degreesHomeLeft.find('form');
        var $subcategory = $degreeForm.find('select[name="subcategory"]');
        var $states = $degreeForm.find('select[name="states"]');
        var $school = $degreeForm.find('input[name="school"]');
        var $offered = $degreeForm.find('input[name="offered"]');
        var $search = $degreeForm.find('.search');
        var $reset = $degreeForm.find('.reset');
        var $bindingSelector;
        try{
            $subcategory.chosen('destroy');
        }catch (e) {}
        $subcategory.chosen();
        $subcategory.unbind();
        try{
            $states.chosen('destroy');
        }catch (e) {}
        $states.chosen();
        $states.unbind();
        nurseslounge_degrees_home.degrees_home_autocomplete(
            $school,
            $params,
            "/degrees/home/autocomplete",
            function($keyword){
                nurseslounge_degrees_home.degrees_home_search($params);
            }
        );
        $subcategory.change(function(){
            try {
                clearTimeout($bindingSelector);
            }catch (e) {
            }
            $bindingSelector = setTimeout(function(){
                nurseslounge_degrees_home.degrees_home_search($params);
            }, 800);
        });
        $states.change(function(){
            try {
                clearTimeout($bindingSelector);
            }catch (e) {
            }
            $bindingSelector = setTimeout(function(){
                nurseslounge_degrees_home.degrees_home_search($params);
            }, 800);
        });
        $offered.unbind().click(function(){
            nurseslounge_degrees_home.degrees_home_search($params);
        });
        $search.unbind().click(function(){
            nurseslounge_degrees_home.degrees_home_search($params);
        });
        $reset.unbind().click(function(){
            $degreeForm[0].reset();
            $subcategory.find('option').prop('selected',false);
            $states.find('option').prop('selected',false);
            nurseslounge_degrees_home.degrees_home_first_load($params);
        });
        nurseslounge_degrees_home.degrees_home_search($params);
    },
    degrees_home_autocomplete:function($target, $params, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({
                        keyword:$($target).val()
                    }, $params),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    degrees_home_search:function($params){
        var $degreesHomeLeft = $("#nurseslounge-degrees-home .nurseslounge-degrees-home-left");
        var $degreeForm = $degreesHomeLeft.find('form');
        var $subcategory = $degreeForm.find('select[name="subcategory"]');
        var $states = $degreeForm.find('select[name="states"]');
        var $school = $degreeForm.find('input[name="school"]');
        var $offered = $degreeForm.find('input[name="offered"]:checked');
        var $degreeList = $degreesHomeLeft.find(".degree-list:first");
        var $degreeListPreview = nurseslounge_degrees_home.degree_preview();
        var $resultInfo = $degreesHomeLeft.find(".result-info-count:first");
        var $resultPreview = '&nbsp;';
        var $paginationNav = $degreesHomeLeft.find('.pagination-nav');
        var $paginationNavPreview = '&nbsp;';
        $params = $.extend({}, $params,{
            subcategory:$subcategory.val(),
            states:$states.val(),
            school:$school.val(),
            offered:$offered.val(),
        });
        $resultInfo.addClass('nurseslounge-degrees-home-preload').html($resultPreview);
        $paginationNav.addClass('nurseslounge-degrees-home-preload').html($paginationNavPreview);
        $degreeList.html($degreeListPreview).promise().done(function(){
            nurseslounge_degrees_home.degree_pagination($params);
        });
    },
    degree_preview:function(){
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        for(var $i=1; $i<=10; $i++){
            $chtml+= '' +
                '<li class="shadow p-3 mb-3 bg-white rounded preview">' +
                '    <div class="row">' +
                '        <div class="col align-self-center">' +
                '            <div class="d-flex">' +
                '                <div class="profile-img mr-4 nurseslounge-degrees-home-preload">' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                </div>' +
                '                <div class="list-info align-self-center w-100">' +
                '                    <h4 class="degree-name nurseslounge-degrees-home-preload">' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '                    </h4>' +
                '                    <p class="degree-university nurseslounge-degrees-home-preload">&nbsp;</p>' +
                '                    <p class="text-muted degree-location nurseslounge-degrees-home-preload">&nbsp;</p>' +
                '                </div>' +
                '            </div>' +
                '        </div>' +
                '        <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '            <div class="clg-rating">' +
                '                <div class="rating-stars mb-1">' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="#E2E2E9"><polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566 "></polygon></svg>' +
                '                </div>' +
                '                <div class="rating-count text-center text-sm-right nurseslounge-degrees-home-preload">' +
                '                &nbsp;' +
                '                </div>' +
                '            </div>' +
                '            <label class="mt-3 p-1 ads nurseslounge-degrees-home-preload">' +
                '               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
                '            </label>';
            if($userId != 'guest'){
                $chtml+= '<button type="button" class="btn btn-save btnAnimate">View</button>';
            }
            $chtml+= '' +
                '        </div>' +
                '    </div>' +
                '</li>';
        }
        return $chtml;
    },
    degree_pagination:function($params){
        var $reload;
        var $loaded = false;
        var $afterFirstPagination = false;
        var $degreesHomeLeft = $("#nurseslounge-degrees-home .nurseslounge-degrees-home-left");
        var $degreeList = $degreesHomeLeft.find('.degree-list');
        var $paginationNav = $degreesHomeLeft.find('.pagination-nav');
        var $previewHeight = $degreesHomeLeft.find('.degree-list .preview:first').innerHeight();
        var $degreeHeight = $degreeList.innerHeight();
        var $pageSize = Math.round(($degreeHeight/$previewHeight));
        var $resultInfo = $degreesHomeLeft.find(".result-info-count:first");
        var $saveParams = $params;
        var $paginationObj;
        try{
            $paginationObj = libs.memoryGet('degree_pagination');
            if($paginationObj){
                $paginationObj.pagination('destroy');
            }
        }catch ($e) {
        }
        $paginationObj = $paginationNav.pagination({
            pageSize: $pageSize,
            showPageNumbers: true,
            showPrevious: true,
            showNext: true,
            showNavigator: true,
            showFirstOnEllipsisShow: true,
            showLastOnEllipsisShow: true,
            dataSource:window.location.protocol +'//'+ window.location.hostname + "/degrees/home/get",
            locator: 'data.degrees',
            ajax:{
                method: "POST",
                cache:false,
                dataType: "json",
                data:$params,
                beforeSend: function() {
                    $degreeList.html(nurseslounge_degrees_home.degree_preview());
                },
                complete:function($data){
                    libs.expire($data.responseJSON);
                }
            },
            totalNumberLocator: function($data) {
                return $data.data.total;
            },
            callback: function($data, $pagination) {
                $loaded = true;
                if($degreeList.length > 0 && $degreeList.offset().top > 0 && $afterFirstPagination){
                    $('html, body').animate({scrollTop:$degreeList.offset().top - 100});
                }else{
                    $afterFirstPagination = true;
                }
                var $pageNumber = $pagination.pageNumber;
                var $pageSize = $pagination.pageSize;
                var $totalNumber = $pagination.totalNumber;
                var $first = $totalNumber > 0 ? (($pageNumber-1) * $pageSize) + 1 : 0;
                var $last = $totalNumber > 0 ? ($first + $data.length - 1) : 0;
                $paginationNav.removeClass('nurseslounge-degrees-home-preload');
                $resultInfo.removeClass('nurseslounge-degrees-home-preload').html('<strong>Showing '+$first+' - '+$last+' of '+$totalNumber+'</strong> results for <span class="link-color">Degrees</span>');
                var $chtml = nurseslounge_degrees_home.degrees_home_item_html($data);
                libs.checkImageLoad($($chtml).find('img'), function () {
                    $degreeList.html('').html($chtml).promise().done(function () {
                        nurseslounge_degrees_home.degrees_home_list_events($saveParams);
                    });
                });
            }
        });
        libs.memorySave('degree_pagination', $paginationObj);
        $reload = setTimeout(function(){
            if(!$loaded){
                nurseslounge_degrees_home.degree_pagination($params);
            }else{
                clearTimeout($reload);
            }
        }, 10000);
    },
    degrees_home_item_html:function($loungeDegrees){
        var $userId = libs.memoryGet('user_id');
        var $chtml = '';
        $.each($loungeDegrees, function($i, $v){
            var $img = $v.lounge.logo_root_lounge;
            $chtml+='' +
                '<li class="shadow p-3 mb-3 bg-white rounded item" data-key="'+$v.key+'" data-public_link="'+$v.public_link+'">';
            $chtml += '<span class="ads">';
            if($v.sponsored == 1) {
                $chtml += '<img src="/bimg/NursesLounge/pin.png">';
            }
            $chtml += '</span>';
            $chtml +=
                '     <div class="row open-degree">' +
                '         <div class="col align-self-center">' +
                '             <div class="d-flex">' +
                '                 <div class="profile-img mr-4">' +
                '                     <img src="'+$img+'?resize=80" alt="hospital" class="p-2">' +
                '                 </div>' +
                '                 <div class="list-info align-self-center w-100">' +
                '                     <h4 class="degree-name">' +
                '                         <a href="javascript:void(0)">'+$v.title+'</a>' +
                '                     </h4>' +
                '                     <p class="degree-university">'+$v.lounge.small_name+'</p>' +
                '                     <p class="text-muted degree-location">';
            if($v.lounge.location.address_city) {
                $chtml+='' +
                    $v.lounge.location.address_city + ', ';
            }
            if($v.lounge.location.address_state) {
                $chtml+='' +
                    $v.lounge.location.address_state;
            }
            $chtml+='' +
                '                     </p>' +
                '                 </div>' +
                '             </div>' +
                '         </div>' +
                '         <div class="col-md-auto text-center text-sm-right align-self-center">' +
                '             <div class="clg-rating">' +
                '                 <div class="rating-stars mb-1">' +
                                    nurseslounge_degrees_home.add_stars($v.rating) +
                '                 </div>' +
                '                 <div class="rating-count text-center text-sm-right">' +
                $v.rating + ' / 5' +
                '                 </div>' +
                '             </div>';
                if($userId != 'guest'){
                    $chtml += '<button type="button" class="btn btn-save btnAnimate open-degree">View</button>';
                }
                $chtml += '' +
                '         </div>' +
                '     </div>' +
                ' </li>';
        });
        return $chtml;
    },
    add_stars:function($rating){
        var $chtml = '';
        for(var $i=1; $i<=5; $i++) {
            var $star = $rating - $i;
            var $offsetOn;
            var $offsetOff;
            var $unique = libs.getUniqueId();
            if($star >= 0){
                $offsetOn = 100;
                $offsetOff = 0;
            }else if($star < 0 && $star > -1){
                $star = ($star * -1);
                $offsetOff = ($star * 100);
                $offsetOn = (100 - $offsetOff);
            }else{
                $offsetOn = 0;
                $offsetOff = 100;
            }
            $chtml += '' +
                '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 12.705 512 486.59" x="0px" y="0px" xml:space="preserve" width="32px" height="32px" fill="url(#percent'+$unique+')">' +
                '   <defs>' +
                '       <linearGradient id="percent'+$unique+'">';
            if($offsetOn > 0) {
                $chtml += '' +
                    '<stop offset="' + $offsetOn + '%" stop-color="#FDA630" stop-opacity="1"></stop>';
            }
            if($offsetOff > 0){
                $chtml += '' +
                    '<stop offset="'+$offsetOff+'%" stop-color="#E2E2E9" stop-opacity="1"></stop>';
            }
            $chtml += '' +
                '       </linearGradient>' +
                '   </defs>' +
                '   <polygon points="256.814,12.705 317.205,198.566 512.631,198.566 354.529,313.435 414.918,499.295 256.814,384.427 98.713,499.295 159.102,313.435 1,198.566 196.426,198.566"></polygon>' +
                '</svg>';
        }
        return $chtml;
    },
    degrees_home_list_events:function($params){
        var $key = $params.key;
        var $userId = libs.memoryGet('user_id');
        var $degreesHomeLeft = $("#nurseslounge-degrees-home .nurseslounge-degrees-home-left");
        var $degreeList = $degreesHomeLeft.find('.degree-list');
        $degreeList.find(".open-degree").unbind().click(function(){
            var $key = $(this).parents('.item:first').data('key');
            var $publicLink = $(this).parents('.item:first').data('public_link');
            if($userId == 'guest'){
                var $params = $.extend({}, {key:$key}, {id:'degrees'});
                public_nurseslounge_lounge_overview.login_popup($params);
                //window.open($publicLink, '_blank');
            }else{
                nurseslounge_lounge_degrees.add_map_show_spu($key);
            }
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-degrees-home .nurseslounge-degrees-home-right .banners")
        });
    },
};
